import { TransformationScene } from "./transformation-scene";
import type { Dimension } from "@src/math/types";
import type { CameraSnapshots } from "../camera-snapshots";
import type { RenderState } from "../render-state";

export interface TransformationSceneHandle {
  dispose(): void;
  getCameraSnapshots(): CameraSnapshots;
  render<D extends Dimension>(state: RenderState<D>): boolean;
  resetView(dimension: Dimension): void;
  restoreCameraSnapshots(snapshots: CameraSnapshots): void;
}

export type TransformationSceneFactory = (
  canvas: HTMLCanvasElement,
  requestRender: () => void,
) => TransformationSceneHandle;

export function createTransformationScene(
  canvas: HTMLCanvasElement,
  requestRender: () => void,
): TransformationSceneHandle {
  if (!(canvas instanceof HTMLCanvasElement))
    throw new Error("Transformation scene requires a canvas");
  return new TransformationScene(canvas, requestRender);
}
